<template>
    <div class="container">
        <specifications-filter />
        <submit-button />
    </div>
</template>

<script>
    import specificationsFilter from './SpecificationsFilter'
    import submitButton from '../SubmitSearchButton'
    export default {
        components: {
            specificationsFilter,
            submitButton
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Auctions/Specification/AuctionSpecifications.vue